import React from "react";

// Assets
import "~/assets/sass/pages/invest/IrModal/finance.scss";
import { thousandFormatter } from "~/utils/formatter";
import { useTranslation } from "react-i18next";

const FinanceView = ({ irFinance }) => {
	const { t } = useTranslation();
	const currentAsset =
		parseInt(irFinance?.quickAsset) +
		parseInt(irFinance?.inventories) +
		parseInt(irFinance?.otherCurrentAsset);
	const nonCurrentAsset =
		parseInt(irFinance?.investment) +
		parseInt(irFinance?.tangibleAsset) +
		parseInt(irFinance?.inTangibleAsset) +
		parseInt(irFinance?.otherNonCurrentAsset);
	const liablities =
		parseInt(irFinance?.currentLiability) + parseInt(irFinance?.nonCurrentLiability);

	const equity =
		parseInt(irFinance?.capital) +
		parseInt(irFinance?.surplus) +
		parseInt(irFinance?.capitalAdjustment) +
		parseInt(irFinance?.otherComprehensiveIncome) +
		parseInt(irFinance?.retainedEarnings);

	const totalAssets = currentAsset + nonCurrentAsset;
	const liabilAndEquity = liablities + equity;

	return (
		<>
			{/*재무정보 view*/}
			<div className="finance-view">
				<div className="data-form">
					<section>
						<h3 className="section-title">
							{t(
								"pages.investment.InvestEvalPage.detail.modal.finance.section1.title"
							)}
						</h3>
						<div className="c__form vertical sub-section">
							<div className="f__group sub-section-table">
								<div className="unit-wrap sub-title">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection1.subTitle"
									)}
									<span className="unit">
										{t(
											"pages.investment.InvestEvalPage.detail.modal.basicInfo.section3.label03-1"
										)}
									</span>
								</div>
								<div className="f__row">
									<div className="f__column">
										<div className="f__group">
											<div className="f__label">
												{t(
													"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection1.label01"
												)}
											</div>
											<div className="f__control">
												{thousandFormatter(currentAsset)}
											</div>
										</div>
									</div>
									<div className="f__field">
										<div className="f__group">
											<div className="f__label">
												{t(
													"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection1.label02"
												)}
											</div>
											<div className="f__control">
												{thousandFormatter(irFinance?.quickAsset)}
											</div>
										</div>
										<div className="f__group">
											<div className="f__label">
												{t(
													"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection1.label03"
												)}
											</div>
											<div className="f__control">
												{thousandFormatter(irFinance?.inventories)}
											</div>
										</div>
										<div className="f__group">
											<div className="f__label">
												{t(
													"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection1.label04"
												)}
											</div>
											<div className="f__control">
												{thousandFormatter(irFinance?.otherCurrentAsset)}
											</div>
										</div>
									</div>
								</div>
								<div className="f__row">
									<div className="f__column">
										<div className="f__group">
											<div className="f__label">
												{t(
													"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection1.label05"
												)}
											</div>
											<div className="f__control">
												{thousandFormatter(nonCurrentAsset)}
											</div>
										</div>
									</div>
									<div className="f__field">
										<div className="f__group">
											<div className="f__label">
												{t(
													"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection1.label06"
												)}
											</div>
											<div className="f__control">
												{thousandFormatter(irFinance?.investment)}
											</div>
										</div>
										<div className="f__group">
											<div className="f__label">
												{t(
													"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection1.label07"
												)}
											</div>
											<div className="f__control">
												{thousandFormatter(irFinance?.tangibleAsset)}
											</div>
										</div>
										<div className="f__group">
											<div className="f__label">
												{t(
													"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection1.label08"
												)}
											</div>
											<div className="f__control">
												{thousandFormatter(irFinance?.inTangibleAsset)}
											</div>
										</div>
										<div className="f__group">
											<div className="f__label">
												{t(
													"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection1.label09"
												)}
											</div>
											<div className="f__control">
												{thousandFormatter(irFinance?.otherNonCurrentAsset)}
											</div>
										</div>
									</div>
								</div>
								<div className="total">
									<div className="total-label">
										{t(
											"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection1.label10"
										)}
									</div>
									<div className="f__control">
										{thousandFormatter(totalAssets)}
									</div>
								</div>
								<dl className="alert-content">
									<div>
										<dt>
											{t(
												"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection1.alertContent.text01"
											)}
										</dt>
										<dd>
											{t(
												"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection1.alertContent.text02"
											)}
										</dd>
									</div>
									<div>
										<dt>
											{t(
												"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection1.alertContent.text03"
											)}
										</dt>
										<dd>
											{t(
												"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection1.alertContent.text04"
											)}
										</dd>
									</div>
									<div>
										<dt>
											{t(
												"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection1.alertContent.text05"
											)}
										</dt>
										<dd>
											{t(
												"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection1.alertContent.text06"
											)}
										</dd>
									</div>
								</dl>
							</div>
							<div className="f__group sub-section-table">
								<div className="unit-wrap sub-title">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection2.subTitle"
									)}
									<span className="unit">
										{t(
											"pages.investment.InvestEvalPage.detail.modal.basicInfo.section3.label03-1"
										)}
									</span>
								</div>
								<div className="f__row">
									<div className="f__column">
										<div className="f__group">
											<div className="f__label">
												{t(
													"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection2.label01"
												)}
											</div>
											<div className="f__control">
												{thousandFormatter(liablities)}
											</div>
										</div>
									</div>
									<div className="f__field">
										<div className="f__group">
											<div className="f__label">
												{t(
													"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection2.label02"
												)}
											</div>
											<div className="f__control">
												{thousandFormatter(irFinance?.currentLiability)}
											</div>
										</div>
										<div className="f__group">
											<div className="f__label">
												{t(
													"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection2.label03"
												)}
											</div>
											<div className="f__control">
												{thousandFormatter(irFinance?.nonCurrentLiability)}
											</div>
										</div>
									</div>
								</div>
								<div className="f__row">
									<div className="f__column">
										<div className="f__group">
											<div className="f__label">
												{t(
													"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection2.label04"
												)}
											</div>
											<div className="f__control">
												{thousandFormatter(equity)}
											</div>
										</div>
									</div>
									<div className="f__field">
										<div className="f__group">
											<div className="f__label">
												{t(
													"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection2.label05"
												)}
											</div>
											<div className="f__control">
												{thousandFormatter(irFinance?.capital)}
											</div>
										</div>
										<div className="f__group">
											<div className="f__label">
												{t(
													"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection2.label06"
												)}
											</div>
											<div className="f__control">
												{thousandFormatter(irFinance?.surplus)}
											</div>
										</div>
										<div className="f__group">
											<div className="f__label">
												{t(
													"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection2.label07"
												)}
											</div>
											<div className="f__control">
												{thousandFormatter(irFinance?.capitalAdjustment)}
											</div>
										</div>
										<div className="f__group">
											<div className="f__label">
												{t(
													"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection2.label08"
												)}
											</div>
											<div className="f__control">
												{thousandFormatter(
													irFinance?.otherComprehensiveIncome
												)}
											</div>
										</div>
										<div className="f__group">
											<div className="f__label">
												{t(
													"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection2.label09"
												)}
											</div>
											<div className="f__control">
												{thousandFormatter(irFinance?.retainedEarnings)}
											</div>
										</div>
									</div>
								</div>
								<div className="total">
									<div className="total-label">
										{t(
											"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection2.label10"
										)}
									</div>
									<div className="f__control">
										{thousandFormatter(liabilAndEquity)}
									</div>
								</div>
								<dl className="alert-content">
									<div>
										<dt>
											{t(
												"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection2.alertContent.text01"
											)}
										</dt>
										<dd>
											{t(
												"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection2.alertContent.text02"
											)}
										</dd>
									</div>
									<div>
										<dt>
											{t(
												"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection2.alertContent.text03"
											)}
										</dt>
										<dd>
											{t(
												"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection2.alertContent.text04"
											)}
										</dd>
									</div>
									<div>
										<dt>
											{t(
												"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection2.alertContent.text05"
											)}
										</dt>
										<dd>
											{t(
												"pages.investment.InvestEvalPage.detail.modal.finance.section1.subSection2.alertContent.text06"
											)}
										</dd>
									</div>
								</dl>
							</div>
						</div>
					</section>
					<section>
						<div className="c__form vertical sub-section ">
							<div className="f__group income-status-table">
								<div className="unit-wrap sub-title">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.finance.section2.title"
									)}
									<span className="unit">
										{t(
											"pages.investment.InvestEvalPage.detail.modal.basicInfo.section3.label03-1"
										)}
									</span>
								</div>
								<ul className="f__control">
									<li>
										<div className="title">
											{t(
												"pages.investment.InvestEvalPage.detail.modal.finance.section2.label01"
											)}
										</div>
										<div className="num">
											{thousandFormatter(irFinance?.sales)}
										</div>
									</li>
									<li>
										<div className="title">
											{t(
												"pages.investment.InvestEvalPage.detail.modal.finance.section2.label02"
											)}
										</div>
										<div className="num">
											{thousandFormatter(irFinance?.cost)}
										</div>
									</li>
									<li>
										<div className="title">
											{t(
												"pages.investment.InvestEvalPage.detail.modal.finance.section2.label03"
											)}
										</div>
										<div className="num">
											{thousandFormatter(irFinance?.sales - irFinance?.cost)}
										</div>
									</li>
									<li>
										<div className="title">
											{t(
												"pages.investment.InvestEvalPage.detail.modal.finance.section2.label04"
											)}
										</div>
										<div className="num">
											{thousandFormatter(irFinance?.sga)}
										</div>
									</li>
									<li>
										<div className="title">
											{t(
												"pages.investment.InvestEvalPage.detail.modal.finance.section2.label06"
											)}
										</div>
										<div className="num">
											{thousandFormatter(
												irFinance?.sales - irFinance?.cost - irFinance?.sga
											)}
										</div>
									</li>
									<li>
										<div className="title">
											{t(
												"pages.investment.InvestEvalPage.detail.modal.finance.section2.label07"
											)}
										</div>
										<div className="num">
											{thousandFormatter(irFinance?.otherIncome)}
										</div>
									</li>
									<li>
										<div className="title">
											{t(
												"pages.investment.InvestEvalPage.detail.modal.finance.section2.label08"
											)}
										</div>
										<div className="num">
											{thousandFormatter(irFinance?.nonOperatingExpenses)}
										</div>
									</li>
									<li>
										<div className="title">
											{t(
												"pages.investment.InvestEvalPage.detail.modal.finance.section2.label09"
											)}
										</div>
										<div className="num">
											{thousandFormatter(
												irFinance?.sales -
													irFinance?.cost -
													irFinance?.sga +
													(irFinance?.otherIncome -
														irFinance?.nonOperatingExpenses)
											)}
										</div>
									</li>
									<li>
										<div className="title">
											{t(
												"pages.investment.InvestEvalPage.detail.modal.finance.section2.label10"
											)}
										</div>
										<div className="num">
											{thousandFormatter(irFinance?.tax)}
										</div>
									</li>
									<li>
										<div className="title">
											{t(
												"pages.investment.InvestEvalPage.detail.modal.finance.section2.label11"
											)}
										</div>
										<div className="num">
											{thousandFormatter(
												irFinance?.sales -
													irFinance?.cost -
													irFinance?.sga +
													(irFinance?.otherIncome -
														irFinance?.nonOperatingExpenses) -
													irFinance?.tax
											)}
										</div>
									</li>
								</ul>
							</div>
						</div>
					</section>
					<section className="debt-status">
						<h3 className="unit-wrap section-title">
							{t(
								"pages.investment.InvestEvalPage.detail.modal.finance.section3.title"
							)}
							<span className="unit">
								{t(
									"pages.investment.InvestEvalPage.detail.modal.basicInfo.section3.label03-1"
								)}
							</span>
						</h3>
						<div className="debt-status-table">
							<div className="thead">
								<div className="tr">
									<div className="th">
										{t(
											"pages.investment.InvestEvalPage.detail.modal.finance.section3.tableHead01"
										)}
									</div>
									<div className="th">
										{t(
											"pages.investment.InvestEvalPage.detail.modal.finance.section3.tableHead02"
										)}
									</div>
									<div className="th">
										{t(
											"pages.investment.InvestEvalPage.detail.modal.finance.section3.tableHead03"
										)}
									</div>
									<div className="th">
										{t(
											"pages.investment.InvestEvalPage.detail.modal.finance.section3.tableHead04"
										)}
									</div>
									<div className="th repayment-condition">
										{t(
											"pages.investment.InvestEvalPage.detail.modal.finance.section3.tableHead05"
										)}
									</div>
								</div>
							</div>
							<div className="tbody">
								{irFinance?.IRFinanceDept?.map((d) => (
									<div className="tr" key={d.idx}>
										<div className="td">{d.borrower}</div>
										<div className="td">{thousandFormatter(d.value)}</div>
										<div className="td">{d.dueDate.substring(0, 10)}</div>
										<div className="td">{d.interestRate}%</div>
										<div className="td repayment-condition">
											{d.repaymentTerms}
										</div>
									</div>
								))}
							</div>
						</div>
					</section>
				</div>
			</div>
		</>
	);
};

export default FinanceView;
